export enum PosMarketingMode {
  Auto = "Auto",
  Manual = "Manual",
  ReceiptOnly = "ReceiptOnly"
}
